module.exports = __webpack_public_path__ + "static/img/共享运营平台2.cfc88ad0.png";